import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';
import { downloadFileFromS3 } from 'utils/function';

const Context = createContext({});

export default function GeneralSettingProvider({ children }) {
  const [generalSetting, setGeneralSetting] = useState();
  const [defaultBounding, setDefaultBounding] = useState();
  useEffect(() => {
    getGeneralSetting();
    getDefaultBounding();
  }, [])

  const getGeneralSetting = async () => {
    try {
      const setting = await downloadFileFromS3('setting/general_setting.json')
      setGeneralSetting(setting);
      document.title = setting.appTitle || 'ENEPEACE';
    }
    catch (e) {
      console.error("ERROR", e);
    }
  }

  const getDefaultBounding = async () => {
    try {
      const bounding = await downloadFileFromS3('setting/default_bounding.json')
      setDefaultBounding(bounding);
    }
    catch (e) {
      console.error("ERROR", e);
    }
  }

  return (
    <Context.Provider value={{ generalSetting, defaultBounding, setGeneralSetting }}>
      {children}
    </Context.Provider>
  );
}

export const useGeneralSetting = () => useContext(Context);
